// CNFT Optimization Constants

/**
 * Threshold for switching between standard and optimized fetching strategies
 * - Collections ≤ this threshold: Use standard fetch with 25-NFT chunks
 * - Collections > this threshold: Use optimized bulk fetch with 100-NFT chunks
 *
 * Set to 100 for testing purposes (original production value: 1000)
 */
export const LARGE_COLLECTION_THRESHOLD = 1000;

/**
 * Chunk sizes for processing NFTs
 */
export const CHUNK_SIZES = {
	STANDARD: 25, // For smaller collections (better UI responsiveness)
	LARGE: 1000, // For large collections (better performance)
} as const;

/**
 * Processing delays in milliseconds
 */
export const PROCESSING_DELAYS = {
	CHUNK_DELAY: 10, // Delay between chunks to prevent UI blocking
} as const;

/**
 * API fetch limits
 */
export const API_LIMITS = {
	FETCH_LIMIT: 1000, // API limit for fetching NFTs per request
} as const;
